module.exports = __webpack_public_path__ + "static/media/college-svgrepo-com 1.741976dc.webp";